import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Match} from './match';

interface Props {
    matches: Match[];
    players;
    onRemove: (matchedPlayersKey: string) => void;
}

class MatchedPlayers extends Component<Props> {
    onRemove(matchedPlayersKey: string): void {
        this.props.onRemove(matchedPlayersKey);
    }
    render() {
        const {matches, players} = this.props;

        return (
            <div className="match-table-holder matched-players">
                <table className="table">
                    <thead>
                        <tr>
                            <th colSpan={2}>Matched Players</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(matches).map((key) => {
                            const {sourcePlayer, targetPlayerId} = matches[key];
                            // @ts-ignore
                            const sourcePlayerName: string = sourcePlayer.name;
                            const targetPlayerName: string = players.getPlayer(targetPlayerId)?.name ?? '';

                            return (
                                <tr key={key}>
                                    <td>{`${sourcePlayerName} - ${targetPlayerName}`}</td>
                                    <td className="td-actions">
                                        <button
                                            type="button"
                                            onClick={(() => this.onRemove(key)).bind(this)}
                                            className="btn-icon"
                                        >
                                            <i className="fa fa-times-circle" />
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {!Object.keys(matches).length && <div className="match-table-empty">Players were not found.</div>}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {players},
    } = state;

    return {
        players,
    };
}

export default connect(mapStatesToProps)(MatchedPlayers);
